export const SET_PRESELECT_PARAMS = "SET_PRESELECT_PARAMS";
export const PRE_SELECT_REQUEST = "PRE_SELECT_REQUEST";
export const PRE_SELECT_SUCCESS = "PRE_SELECT_SUCCESS";
export const PRE_SELECT_FAILURE = "PRE_SELECT_FAILURE";
